import 'datatables.net-bs5'
import 'datatables.net-responsive-bs'

window.datatablesDefaults = {
  language: {
    paginate: {
      previous: '<span class="page-link">&nbsp;</span>',
      next: '<span class="page-link">&nbsp;</span>',
    },
    sSearch: '<span><i class="fal fa-search"></i></span>',
    emptyTable: 'Aucun résultat',
    sInfo: '_START_ à _END_ sur _TOTAL_',
    infoEmpty: '0 à 0 sur 0',
    infoFiltered: '(filtrée sur _MAX_)',
    zeroRecords: 'Aucun résultat',
    loadingRecords: 'Chargement ...',
    processing: 'Traitement ...',
    searchPlaceholder: 'Recherche',
    lengthMenu: 'Voir _MENU_'
  },
  classes: {
    sPageButton: 'page-item',
    sPageButtonActive: 'page-item',
  }
}

function toggleDisabledClass(checkboxClass, btnClass, inputClass) {
  let checkBoxes = document.querySelectorAll(checkboxClass)
  let checkCount = 0
  let checkIds = []

  checkBoxes.forEach((checkBox) => {
    const elementId = checkBox.dataset.id
    if (checkBox.checked) {
      checkCount += 1
      checkIds.push(elementId)
    } else {
      const index = checkIds.indexOf(elementId)
      if (index >= 0) {
        checkIds.splice(index, 1)
      }
    }
  })

  if (checkCount === 0) {
    $(btnClass).addClass('disabled')
    $(btnClass).addClass('text-disabled-green')
    $(btnClass).removeClass('text-dark-green')
    $('.distribute-btn').prop('disabled', true)
    $('.distribute-btn').addClass('text-disabled-green')
    $('.distribute-btn').removeClass('text-dark-green')
  } else {
    $(btnClass).removeClass('disabled')
    $(btnClass).removeClass('text-disabled-green')
    $(btnClass).addClass('text-dark-green')
    $('.distribute-btn').prop('disabled', false)
    $('.distribute-btn').removeClass('text-disabled-green')
    $('.distribute-btn').addClass('text-dark-green')
  }

  $(inputClass).val(checkIds.toString())
}

document.addEventListener('turbo:load', () => {
  // My classrooms
  $('#my-classrooms-checkboxes').on('click', function() {
    let checkBoxes = document.querySelectorAll('.my-classrooms-checkbox')
    checkBoxes.forEach((checkBox) => {
      checkBox.checked = $('#my-classrooms-checkboxes').is(':checked')
    })
    toggleDisabledClass('.my-classrooms-checkbox', '.my-classrooms-btn', '.my-classrooms-input')
  })

  $('.my-classrooms-checkbox').on('change', function() {
    toggleDisabledClass('.my-classrooms-checkbox', '.my-classrooms-btn', '.my-classrooms-input')
  })

  // Classrooms shared
  $('#classrooms-shared-checkboxes').on('click', function() {
    let checkBoxes = document.querySelectorAll('.classrooms-shared-checkbox')
    checkBoxes.forEach((checkBox) => {
      checkBox.checked = $('#classrooms-shared-checkboxes').is(':checked')
    })
    toggleDisabledClass('.classrooms-shared-checkbox', '.classrooms-shared-btn', '.classrooms-shared-input')
  })

  $('.classrooms-shared-checkbox').on('change', function() {
    toggleDisabledClass('.classrooms-shared-checkbox', '.classrooms-shared-btn', '.classrooms-shared-input')
  })

  // Students
  $('#students-checkboxes').on('click', function() {
    let checkBoxes = document.querySelectorAll('.students-checkbox')
    checkBoxes.forEach((checkBox) => {
      checkBox.checked = $('#students-checkboxes').is(':checked')
    })
    toggleDisabledClass('.students-checkbox', '.students-btn', '.students-input')
  })

  $('.students-checkbox').on('change', function() {
    toggleDisabledClass('.students-checkbox', '.students-btn', '.students-input')
  })

  // Observations
  $('#observations-checkboxes').on('click', function() {
    let checkBoxes = document.querySelectorAll('.observations-checkbox')
    checkBoxes.forEach((checkBox) => {
      checkBox.checked = $('#observations-checkboxes').is(':checked')
    })
    toggleDisabledClass('.observations-checkbox', '.observations-btn', '.observations-input')
  })

  $('.observations-checkbox').on('change', function() {
    toggleDisabledClass('.observations-checkbox', '.observations-btn', '.observations-input')
  })
})
